'use client'

import { useHomeOrderTypeSync } from '@/app/[locale]/_hooks/useHomeOrderTypeSync'

/**
 * Tiny client mount for home-page order type soft sync.
 * Keeps HomeContent as a server component.
 */
export default function HomeOrderTypeSync({
  serverDeliveryType,
}: {
  serverDeliveryType?: string
}) {
  useHomeOrderTypeSync(serverDeliveryType)
  return null
}
